import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { CarnivalService } from '../carnival-management/carnival.service';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-event-review',
  templateUrl: './event-review.component.html',
  styleUrls: ['./event-review.component.scss']
})
export class EventReviewComponent implements OnInit {
  constructor(private spinner:NgxSpinnerService,private carnivalService:CarnivalService) { }
  pageLimit:any
  loadingIndicator:any
  reorderable:any
  ngOnInit() {
    this.getEventReviewList();
  }
  eventList:any;
  getEventReviewList() {
    let query = '';
    // var queryValue = this.queryParams();
    this.spinner.show();
  this.carnivalService.getEventsReviewApi(query).subscribe(
    res => {
      this.spinner.hide();
      if ((res["message"] == "Success")) {
        this.eventList = res["data"]["reviewList"];
      } else {
        this.eventList = [];
      }
      this.spinner.hide();
    },
    err => {
      this.spinner.hide();
    }
  );
  }
     searchBusinessFilters() {
    this.getEventReviewList();
  }

  deleteEventAction(title,eventId) {
      Swal.fire({
        title: "You Want to delete this review : " +title ,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.value) {
          let query = eventId+ "?isAdmin=true"
          
          this.spinner.show();
          this.carnivalService.deleteReviewApi(eventId).subscribe(
            res => {
              this.spinner.hide();
              if (res["message"] == "Success") {
                Swal.fire("Success", "Review deleted successfully!", "success");
              } else {
                Swal.fire("Error", res.data, "error");
              }
              this.spinner.hide();
              this.getEventReviewList();
            },
            err => {
              this.spinner.hide();
            }
          );
        }
      });
    }
  
    showImageModal(image: any) {
      if (image) {
        Swal.fire({
          title: "Cover Image",
          imageUrl: image,
          imageHeight: 250,
          imageWidth: 250,
          customClass: {
            title: "title-class11"
          }
        });
      }
    }

    // onReset() {
    //   this.spinner.show();
    //   setTimeout(() => {
    //     /** spinner ends after 5 seconds */
    //     this.spinner.hide();
    //   }, 2000);
    //     (this.searchStartDate = ""),
    //     (this.searchEndDate = "");
    //   this.getCarnivalList();
    // }




}
